import { createSelector } from 'reselect';
export const getEsbConfig = (state) => {
    var _a, _b;
    return ((_b = (_a = state.esb.esbConfigMap) === null || _a === void 0 ? void 0 : _a[state.esb.esbPartner || '']) !== null && _b !== void 0 ? _b : null);
};
export const getEsbPartnerName = createSelector([getEsbConfig], (esbConfig) => { var _a; return (_a = esbConfig === null || esbConfig === void 0 ? void 0 : esbConfig.name) !== null && _a !== void 0 ? _a : 'your platform'; });
